export default {"src":"/_next/static/media/loading-icon.3e29f463.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};